import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/close_icon.svg'
import _imports_1 from '@/assets/recommended-popup-icon.svg'
import _imports_2 from '@/assets/arrow.svg'


const _hoisted_1 = {
  key: 0,
  "data-testid": "recommendedPopup",
  class: "recommended-popup-container",
  "cy-data": "popup"
}
const _hoisted_2 = { class: "recommended-popup" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close icon"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "icon"
  })
], -1)
const _hoisted_6 = { class: "recommended-popup-title" }
const _hoisted_7 = { class: "recommended-popup-p" }
const _hoisted_8 = { class: "recommended-popup-p" }
const _hoisted_9 = { class: "recommended-popup-buttons" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "arrow icon"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                class: "close-btn",
                "aria-label": "Close popup",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, _hoisted_4),
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.mobileAccuracyHeader`)), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.mobileAccuracyDescription`)), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.limitationsAcknowledgement`)), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  "data-testid": "btn-recommendedPopup-next",
                  class: "understand-btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBackToMobileUpload && _ctx.handleBackToMobileUpload(...args)))
                }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.proceedButton`)), 1),
                _createElementVNode("button", {
                  "data-testid": "btn-recommendedPopup-back",
                  type: "button",
                  class: "action-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                }, [
                  _hoisted_10,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.backToMobileUploadButton`)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}